import { Input } from '@/components/ui/input';
import { FormField } from '@/shared/components/form';

interface Props {
  id: string;
  label: string;
  value: number | null;
  onChange: (value: number | null) => void;
  error?: string;
  hint?: string;
  disabled?: boolean;
  max?: number;
  step?: number;
  /** An empty box means null (e.g. an unknown distance); otherwise it means 0. */
  allowEmpty?: boolean;
  className?: string;
  /** Greyed text in an empty box, e.g. the automatic discount an empty box means. */
  placeholder?: string;
}

export function NumberField({ id, label, value, onChange, error, hint, disabled, max, step = 1, allowEmpty = false, className, placeholder }: Props) {
  return (
    <FormField label={label} htmlFor={id} error={error} hint={hint} className={className}>
      <Input
        id={id}
        type="number"
        inputMode="decimal"
        min={0}
        max={max}
        step={step}
        disabled={disabled}
        aria-invalid={!!error}
        value={value ?? ''}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value === '' ? (allowEmpty ? null : 0) : Number(e.target.value))}
      />
    </FormField>
  );
}
